import React, { useContext, useEffect, useState } from 'react';

import {
  TreeSelect,
  Row,
  Col,
  Select,
  Switch,
  message,
  Divider,
  Table,
  Checkbox,
  Button,
  Tooltip,
} from 'antd';
import { Context } from '../../../defaults';
import {
  getInstitutionByTypeId,
  getInstitutions,
  getInstitutionsType,
  GetClassesWithStudentsByInstitutionId,
  changeActive,
  getAuthorizedPersonsProfile,
} from '../../../actions';
import { groupBy } from '../../../utils';
import { userRole } from '../../../common';

const StudentsSwitcher = ({ dictionary, language }) => {
  const { TreeNode } = TreeSelect;

  const { setLoading } = useContext(Context);
  const [institutions, setInstitutions] = useState();
  const [page, setPage] = useState(1);
  const [selectedInstitutionType, setSelectedInstitutionType] = useState();
  const [institutionsType, setInstitutionsType] = useState();
  const [groupedInstitutions, setGroupedInstitutions] = useState({});
  const [selectedInstitution, setSelectedInstitution] = useState();
  const [selectedClasses, setSelectedClasses] = useState();
  const [allInstitutionClasses, setAllInstitutionClasses] = useState();
  const [checkAll, setCheckAll] = useState(false);

  const onSelectInstitution = (value) => {
    'director' !== userRole() && setSelectedInstitution(institutions.filter((x) => x.id === value)[0]);
    GetClassesWithStudentsByInstitutionId(value).then(({ data }) => setAllInstitutionClasses(data));
    setSelectedClasses(null);
  };

  const onSaveChanges = () => {
    setLoading(true);
    changeActive(selectedClasses)
      .then(() => {
        setLoading(false);
        message.success(dictionary?.SuccessfullyChanged[language], 4);
      })
      .catch(() => {
        message.error(dictionary?.SomethingWentWrong[language], 4);
        setLoading(false);
      });
  };

  const columns = [
    {
      title: `№`,
      dataIndex: 'number',
      key: 'number',
      fixed: 'left',
      render: (text, record, index) => (page - 1) * 10 + (index + 1),
    },
    {
      title: `${dictionary?.FullName[language]}`,
      key: 'FIO',
      fixed: 'left',
      render: (text, record, index) => {
        return <span>{text.lastName + ' ' + text.firstName + ' ' + text.middleName}</span>;
      },
    },
    {
      title: `${dictionary?.Activity[language]}`,
      key: 'action',
      width: 100,
      fixed: 'right',
      render: (text, record, index) => (
        <Switch checked={text.users.active} onChange={() => onChangeStudentActive(text)} />
      ),
    },
  ];

  const filterInstitutionsByTypeId = (id) => {
    setLoading(true);
    setSelectedClasses();
    getInstitutionByTypeId(id).then((res) => {
      setSelectedInstitutionType(id);
      setGroupedInstitutions(groupBy(res.data, 'city'));
      setInstitutions(res.data);
      setLoading(false);
    });
  };

  const onChangeStudentActive = (e) => {
    const updatedStudents = selectedClasses.students.map((st) => {
      return st.id === e.id ? { ...st, users: { ...st.users, active: e.users.active ? 0 : 1 } } : { ...st };
    });
    setSelectedClasses({ ...selectedClasses, students: updatedStudents });
  };

  const onCheckAllChange = () => {
    setCheckAll(!checkAll);
    const updatedStudents = selectedClasses.students.map((st) => {
      return {
        ...st, users: { ...st.users, active: !checkAll ? 0 : 1 }
      };
    });
    setSelectedClasses({ ...selectedClasses, students: updatedStudents });
  };

  useEffect(() => {
    getInstitutions().then(({ data }) => setInstitutions(data));
    getInstitutionsType().then(({ data }) => setInstitutionsType(data));

    if ('director' === userRole()) {
      setLoading(true);
      getAuthorizedPersonsProfile()
        .then(({ data }) => {
          filterInstitutionsByTypeId(data?.institution?.institutionTypeId);
          setSelectedInstitution(data?.institution);
          onSelectInstitution(data?.institution?.id);
          setLoading(false);
        })
        .catch(() => {
          message.error(dictionary?.SomethingWentWrong[language], { duration: 4 });
          setLoading(false);
        });
    }
  }, []);
  return (
    <React.Fragment>
      <Row style={{ marginTop: '30px' }} gutter={16}>
        <Col span={8}>
          <Select
            placeholder={dictionary?.InstitutionType[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            disabled={'director' === userRole()}
            value={selectedInstitutionType}
            onChange={(value) => filterInstitutionsByTypeId(value)}>
            {institutionsType &&
              institutionsType.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {el.name}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
        <Col span={8}>
          <TreeSelect
            showSearch
            style={{ width: '100%' }}
            size="large"
            disabled={'director' === userRole() || !selectedInstitutionType}
            value={selectedInstitution?.id}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            placeholder={dictionary?.SelectInstitutionOrSearch[language]}
            allowClear
            treeDefaultExpandAll
            onChange={onSelectInstitution}
            filterTreeNode={(search, item) => {
              return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}>
            {groupedInstitutions &&
              Object.keys(groupedInstitutions).map((key, index) => {
                return (
                  <TreeNode title={key} key={`city${key}${index}`} disabled>
                    {groupedInstitutions[key].map((value) => {
                      return <TreeNode value={value.id} title={value.name} key={value.id} />;
                    })}
                  </TreeNode>
                );
              })}
          </TreeSelect>
        </Col>
        <Col span={8}>
          <Select
            placeholder={dictionary?.ClassesList[language]}
            size="large"
            style={{ width: '100%' }}
            allowClear={true}
            disabled={!selectedInstitution}
            value={selectedClasses?.id}
            filterOption={(search, item) => {
              return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
            }}
            onChange={(value) =>
              setSelectedClasses(allInstitutionClasses.find((i) => i.id === value))
            }>
            {allInstitutionClasses &&
              allInstitutionClasses.map((el) => {
                return (
                  <Select.Option value={el.id} key={el.id}>
                    {`${el.year} ${el.letter}`}
                  </Select.Option>
                );
              })}
          </Select>
        </Col>
      </Row>
      {!!selectedClasses && (
        <>
          <Divider orientation="left">
            {dictionary?.StudentsList[language]}
            <Checkbox
              onChange={onCheckAllChange}
              checked={checkAll}
              style={{ marginLeft: 20 }}
              disabled={selectedClasses.students.length === 0}>
              {dictionary?.SelectAll[language]}
            </Checkbox>
            <Button
              type="primary"
              htmlType="submit"
              onClick={() => onSaveChanges()}
              disabled={selectedClasses.students.length === 0}
              style={{ marginLeft: 40 }}>
              {dictionary?.Save[language]}
            </Button>
          </Divider>
          <Table
            columns={columns}
            dataSource={selectedClasses.students}
            rowKey="id"
            pagination={{
              onChange(current) {
                setPage(current);
              },
            }}
          />
        </>
      )}
    </React.Fragment>
  );
};
export default StudentsSwitcher;
